"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import DropCurationButton from "@/components/waves/drops/DropCurationButton";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { startDropOpen } from "@/utils/monitoring/dropOpenTiming";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { WaveLeaderboardDropContent } from "../content/WaveLeaderboardDropContent";
import { WaveLeaderboardDropFooter } from "./footer/WaveLeaderboardDropFooter";
import { WaveLeaderboardDropAuthorAvatar } from "./header/WaveLeaderboardDropAuthor";
import { WaveLeaderboardDropHeader } from "./header/WaveLeaderboardDropHeader";
import { WaveLeaderboardDropRaters } from "./header/WaveleaderboardDropRaters";
interface DefaultWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const DefaultWaveLeaderboardDrop: React.FC<DefaultWaveLeaderboardDropProps> = t0 => {
  const $ = _c(66);
  const {
    drop,
    onDropClick
  } = t0;
  const {
    canShowVote,
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const isMobileScreen = useIsMobileScreen();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen,
      preventDefault: false
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  const getBorderClasses = _temp;
  let t2;
  if ($[2] !== drop || $[3] !== isMobileScreen || $[4] !== onDropClick) {
    t2 = () => {
      startDropOpen({
        dropId: drop.id,
        waveId: drop.wave.id,
        source: "leaderboard_list",
        isMobile: isMobileScreen
      });
      onDropClick(drop);
    };
    $[2] = drop;
    $[3] = isMobileScreen;
    $[4] = onDropClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== drop) {
    t3 = <div className="tw-flex-shrink-0 tw-self-start"><WaveLeaderboardDropAuthorAvatar drop={drop} /></div>;
    $[6] = drop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== drop) {
    t4 = <WaveLeaderboardDropHeader drop={drop} showAvatar={false} />;
    $[8] = drop;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== drop) {
    t5 = <div className="tw-hidden tw-h-8 lg:tw-block"><WaveDropActionsOpen drop={drop} /></div>;
    $[10] = drop;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== canDelete || $[13] !== drop) {
    t6 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[12] = canDelete;
    $[13] = drop;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div className="tw-hidden tw-h-8 lg:tw-block">{t6}</div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="tw-flex tw-items-center">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t8) {
    t9 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t4}{t8}</div>;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== drop) {
    t10 = <WaveLeaderboardDropContent drop={drop} isCompetitionDrop={true} />;
    $[23] = drop;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== drop) {
    t11 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2"><WaveLeaderboardDropRaters drop={drop} /><WaveLeaderboardDropFooter drop={drop} /></div>;
    $[25] = drop;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = drop.context_profile_context?.curatable ?? false;
  const t13 = drop.context_profile_context?.curated ?? false;
  let t14;
  if ($[27] !== drop.id || $[28] !== drop.wave.id || $[29] !== t12 || $[30] !== t13) {
    t14 = <DropCurationButton waveId={drop.wave.id} dropId={drop.id} isCuratable={t12} isCurated={t13} />;
    $[27] = drop.id;
    $[28] = drop.wave.id;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== canShowVote || $[33] !== drop) {
    t15 = canShowVote && <VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} className="tw-font-semibold" />;
    $[32] = canShowVote;
    $[33] = drop;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15) {
    t16 = <div className="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-t-0 @[700px]:tw-pt-0" onClick={_temp2}>{t14}{t15}</div>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t11 || $[39] !== t16) {
    t17 = <div className="tw-mt-3 tw-flex tw-w-full tw-flex-col tw-justify-between tw-gap-x-2 tw-space-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-space-y-0">{t11}{t16}</div>;
    $[38] = t11;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t10 || $[42] !== t17 || $[43] !== t9) {
    t18 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">{t9}{t10}{t17}</div>;
    $[41] = t10;
    $[42] = t17;
    $[43] = t9;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t18 || $[46] !== t3) {
    t19 = <div className="tw-flex tw-gap-x-3">{t3}{t18}</div>;
    $[45] = t18;
    $[46] = t3;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t19 || $[49] !== touchHandlers) {
    t20 = <div className={getBorderClasses()} {...touchHandlers}>{t19}</div>;
    $[48] = t19;
    $[49] = touchHandlers;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== drop || $[52] !== isMobileScreen || $[53] !== isVotingModalOpen) {
    t21 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[51] = drop;
    $[52] = isMobileScreen;
    $[53] = isVotingModalOpen;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== canDelete || $[56] !== drop || $[57] !== hasTouchScreen || $[58] !== isActive || $[59] !== setIsActive) {
    t22 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[55] = canDelete;
    $[56] = drop;
    $[57] = hasTouchScreen;
    $[58] = isActive;
    $[59] = setIsActive;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== t2 || $[62] !== t20 || $[63] !== t21 || $[64] !== t22) {
    t23 = <div onClick={t2} className="tw-group tw-relative tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-@container">{t20}{t21}{t22}</div>;
    $[61] = t2;
    $[62] = t20;
    $[63] = t21;
    $[64] = t22;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  return t23;
};
function _temp() {
  return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-iron-700";
}
function _temp2(e) {
  return e.stopPropagation();
}